module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-4-b7c2d40aec67fcc44cac11f2dbf96776.jpg";